(function() {
    'use strict';

    angular
        .module('adjustBenApp')
        .controller('BenCancelReasonDialogController', BenCancelReasonDialogController);

    BenCancelReasonDialogController.$inject = ['$scope', '$uibModalInstance', 'lstBenReason', 'adjustBen', 'AdjustBenService'];

    function BenCancelReasonDialogController ($scope, $uibModalInstance, lstBenReason, adjustBen, AdjustBenService) {
    	var cancelReasonDlgCtr = this;
    	cancelReasonDlgCtr.lstBenReason = lstBenReason;
    	cancelReasonDlgCtr.cancel= cancel;
    	cancelReasonDlgCtr.cancelReason = cancelReason;
    	cancelReasonDlgCtr.errorMessage = null;
    	  function cancelReason() {
    		  adjustBen.remarkId = cancelReasonDlgCtr.remarkId;
    		 AdjustBenService.post({uri:'doCancelBen'},adjustBen, 
    		 function (result){
    			 $uibModalInstance.close(result);
    		 }, function (error){
    			 if(error.data.errorDTO != null){
    				 cancelReasonDlgCtr.errorMessage = error.data.errorDTO.message;
         		}
    		 });  
    	    
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    }
})();
